export default __webpack_public_path__ + "static/media/explodedfullview.77d81637.png";